import propertyTypeRules from '../config/propertyTypeRules.json';

export const PROPERTY_TYPE_VALUES = {
  LAND: 'land',
  HOUSE_OR_OTHER_BUILDING: 'house_or_other_building',
  UNIT: 'unit',
};

function normalizeForMatch(value) {
  return String(value || '')
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .replace(/[.,;:]+$/g, '');
}

function includesAnyKeyword(source, keywords) {
  return Array.isArray(keywords) && keywords.some((k) => source.includes(k));
}

export function detectPropertyTypeFromSummary(summary) {
  if (!summary || typeof summary !== 'object') {
    return PROPERTY_TYPE_VALUES.HOUSE_OR_OTHER_BUILDING;
  }

  const usage = normalizeForMatch(summary.vyuziti);

  if (includesAnyKeyword(usage, propertyTypeRules.unit)) {
    return PROPERTY_TYPE_VALUES.UNIT;
  }
  if (includesAnyKeyword(usage, propertyTypeRules.house_or_other_building)) {
    return PROPERTY_TYPE_VALUES.HOUSE_OR_OTHER_BUILDING;
  }
  if (includesAnyKeyword(usage, propertyTypeRules.land)) {
    return PROPERTY_TYPE_VALUES.LAND;
  }

  if (summary.hasUnit) return PROPERTY_TYPE_VALUES.UNIT;
  if (summary.hasBuildingLinkedInParcels) return PROPERTY_TYPE_VALUES.HOUSE_OR_OTHER_BUILDING;
  if (summary.hasStavba) return PROPERTY_TYPE_VALUES.HOUSE_OR_OTHER_BUILDING;
  if (summary.hasPozemky) return PROPERTY_TYPE_VALUES.LAND;
  if (summary.hasStavbaOrPozemky) return PROPERTY_TYPE_VALUES.HOUSE_OR_OTHER_BUILDING;
  return PROPERTY_TYPE_VALUES.HOUSE_OR_OTHER_BUILDING;
}

export { normalizeForMatch };
